import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import { INestedFormPopulate } from 'Models/BOB/ResponseModels/Life/QuestionSet'
import {
  IPolicyItem,
  RaiseClaimResponse,
  ITicketDetails,
  IProposalDetails,
  HealthProposalDetails,
} from 'Pages/Customer360/types'
import { baseUrlQuery, healthUrlQuery } from 'Services/baseQuery'

interface IdynamicObject {
  [key: string]: any
}

export interface IRaiseEndorsementRequest {
  pas_id: string
  insurance_category: string
  endorsement_type: string
  endorsement_data: IdynamicObject
  changed_fields: IdynamicObject
}

export const bobHealthAPi360 = createApi({
  reducerPath: 'healthAPi360',
  baseQuery: healthUrlQuery,
  endpoints: (builder) => ({
    getHealthProposalDetails: builder.query<
      {
        data: HealthProposalDetails
        message: string
        num_pages: number
        page: number
        status: number
      },
      Record<string, string>
    >({
      query: (filters) => ({
        url: `${API_ENDPOINTS.BOB.HEALTH_GET_PROPOSAL_DETAILS}`,
        method: 'GET',
        params: filters,
        rawResponse: true,
      }),
    }),
  }),
})

export const { useGetHealthProposalDetailsQuery,useLazyGetHealthProposalDetailsQuery } = bobHealthAPi360
